import * as React from "react";
import { Post } from "../../../../interfaces";
import "./styles.scss";
import { Button, Modal } from "semantic-ui-react";
import { useEffect } from "react";
import { PostServices } from "../../../../services";
import pluralize from "pluralize";
import { DateTimePicker } from "@/components/DateTimePicker";
import { useQueryClient } from "@tanstack/react-query";

type Props = {
  open: boolean;
  posts: Post[];
  currentScheduledDateTime: Date;
  onClose: () => void;
  onPostsRescheduled: () => void;
};

export const ReschedulePostsModal: React.FC<Props> = ({
  open,
  posts,
  currentScheduledDateTime,
  onClose,
  onPostsRescheduled,
}) => {
  const queryClient = useQueryClient();
  const [rescheduledDateTime, setRescheduledDateTime] = React.useState<Date>(new Date());
  const [isUpdating, setIsUpdating] = React.useState<boolean>(false);

  useEffect(() => {
    setRescheduledDateTime(currentScheduledDateTime);
  }, [currentScheduledDateTime]);

  const reschedulePosts = () => {
    setIsUpdating(true);
    const updatePromises = posts.map(post => {
      const socialNetworkMessages = post.socialNetworks.map(sn => ({
        code: sn.socialNetworkId,
        socialNetworkMessage: sn.caption,
      }));
      return PostServices.update(
        post.postId,
        socialNetworkMessages,
        post.message,
        rescheduledDateTime.toISOString(),
        post.mediaGroup
      );
    });
    Promise.all(updatePromises)
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ["calendarEvents"] });
        onPostsRescheduled();
      })
      .finally(() => setIsUpdating(false));
  };

  const handleChange = (date: Date | undefined) => {
    setRescheduledDateTime(date || new Date());
  };

  return (
    <Modal open={open} onClose={onClose} size="tiny" className="secondaryModal">
      <Modal.Header>
        When would you like to send the {posts.length} selected {pluralize("post", posts.length)}?
      </Modal.Header>
      <Modal.Content className="centerTextAlign">
        <DateTimePicker
          selectedDate={rescheduledDateTime}
          selectedTime={rescheduledDateTime}
          onChangeDate={handleChange}
          onChangeTime={handleChange}
          minDate={new Date()}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button secondary loading={isUpdating} onClick={onClose} content="Cancel" />
        <Button
          primary
          loading={isUpdating}
          onClick={reschedulePosts}
          disabled={rescheduledDateTime.toISOString() === currentScheduledDateTime.toISOString()}
          content="Reschedule"
        />
      </Modal.Actions>
    </Modal>
  );
};
